import { Modal, Form, Input, Button } from "antd";
import { useRef, useState, useEffect } from "react";
import Draggable from "react-draggable";

import { formItemLayout, inputLayout } from "../../../../constants/ApplicationConstants/FormConstants";
import CircularProgressBar from "../../../common/CircularProgressBar";
import Loading from "../../../common/Loading";
import FormInputRules from "../../../../util/FormInputRules";
import { General } from "../../../../util/General";
import styles from "../../index.module.less";
import { useReactDraggable } from "../../../../hooks/useReactDraggable";

import type FixMeLater from "../../../../shared/types/fixMeLater.type";

type VehicleTypeMasterProps = {
  saving: boolean;
  addRecord: boolean;
  handleAddRecord: (value: boolean) => void;
  rowData: FixMeLater;
  handleClearRowIdAndActionType: () => void;
  handleSubmit: (data: FixMeLater) => void;
};

const VehicleTypeMaster = (props: VehicleTypeMasterProps) => {
  /* CONSTANTS */
  const [form] = Form.useForm();
  const formRef = useRef<FixMeLater>(null);

  /* STATES */
  const [formFieldsLoadedToForm, setFormFieldsLoadedToForm] = useState(false);

  /* CUSTOM HOOKS */
  const { bounds, onStart } = useReactDraggable();

  /* HANDLERS */

  /* loading states from multiple hooks added as expression */
  const isOnAddLoading = !props.addRecord;
  const isOnEditLoading = !!props.addRecord;

  /* EFFECTS */
  useEffect(() => {
    if (!props.addRecord && !isOnEditLoading && !formFieldsLoadedToForm) {
      form.setFieldsValue(props.rowData);
      setFormFieldsLoadedToForm(true);
    }
  }, [isOnEditLoading]);

  return (
    <Modal
      afterClose={() => form.resetFields()}
      destroyOnClose={true}
      maskClosable={false}
      centered
      title={<div className="modal-container">{`${props.addRecord ? "Add" : "Edit"} Vehicle Type Master`}</div>}
      open={true}
      onCancel={props.addRecord ? props.handleAddRecord.bind(this, false) : props.handleClearRowIdAndActionType}
      width={"50%"}
      okButtonProps={{
        style: {
          display: "none"
        }
      }}
      cancelButtonProps={{ style: { display: "none" } }}
      modalRender={(modal) => (
        <Draggable bounds={bounds} handle=".ant-modal-header" onStart={(event, uiData) => onStart(event as any, uiData)}>
          {modal}
        </Draggable>
      )}
    >
      {((props.addRecord && isOnAddLoading) || (!props.addRecord && !formFieldsLoadedToForm)) && (
        <div className={`${styles["textCenter"]}`}>
          <Loading />
        </div>
      )}

      {((props.addRecord && !isOnAddLoading) || (!props.addRecord && formFieldsLoadedToForm)) && (
        <Form
          ref={formRef}
          onValuesChange={(changedValues) => {
            const fieldName = Object.keys(changedValues)[0];
            form.validateFields([fieldName]);
          }}
          className={`${styles["formDiv"]}`}
          {...formItemLayout}
          form={form}
          validateTrigger="onBlur"
          colon={false}
          name="register"
          onFinish={props.handleSubmit}
        >
          <Form.Item {...inputLayout} name="vehicle_type_name" label="Vehicle Type Name" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("vehicle type name")]}>
            <Input name="vehicle_type_name" />
          </Form.Item>
          <Form.Item {...inputLayout} name="description" label="Description" normalize={General.inputWhiteSpaceRemove}>
            <Input name="description" />
          </Form.Item>

          <Form.Item className={`${styles["form-itemFloatR20"]}`}>
            <Button htmlType="submit" className={`gx-mb-0 button-gradiant ${styles["button-m01"]}`}>
              {props.saving ? <CircularProgressBar /> : props.addRecord ? "Submit" : "Update"}
            </Button>
          </Form.Item>

          <Form.Item className={`${styles["form-itemFloatR20"]}`}>
            <Button disabled={props.saving} className={`gx-mb-0 button-gradiant ${styles["button-m01"]}`} onClick={props.addRecord ? props.handleAddRecord.bind(this, false) : props.handleClearRowIdAndActionType}>
              Close
            </Button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default VehicleTypeMaster;
